/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No words found for ${i?.letters}.`)
};

const es_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontraron palabras para ${i?.letters}.`)
};

const de_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keine Wörter für ${i?.letters} gefunden.`)
};

const nl_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geen woorden gevonden voor ${i?.letters}.`)
};

const fr_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun mot trouvé pour ${i?.letters}.`)
};

const it_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessuna parola trovata per ${i?.letters}.`)
};

const pt_br2_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhuma palavra encontrada para ${i?.letters}.`)
};

const pt_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foram encontradas palavras para ${i?.letters}.`)
};

const ja_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.letters} に一致する単語が見つかりませんでした。`)
};

const zh_wu_no_results = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未找到与 ${i?.letters} 匹配的单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ letters: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_no_results = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_no_results(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_no_results", locale)
	if (locale === "en") return en_wu_no_results(inputs)
	if (locale === "es") return es_wu_no_results(inputs)
	if (locale === "de") return de_wu_no_results(inputs)
	if (locale === "nl") return nl_wu_no_results(inputs)
	if (locale === "fr") return fr_wu_no_results(inputs)
	if (locale === "it") return it_wu_no_results(inputs)
	if (locale === "pt-BR") return pt_br2_wu_no_results(inputs)
	if (locale === "pt") return pt_wu_no_results(inputs)
	if (locale === "ja") return ja_wu_no_results(inputs)
	return zh_wu_no_results(inputs)
};